import bar from './bar/';
import line from './line/';
import scatter from './scatter/';
import xyHeatmap from './xy-heatmap/';
import treemap from './treemap/';
import parCoords from './par-coords/';
import pie from './pie/';
import markerMap from './marker-map/';
import combo from './combo/';
const _layout = {bar, line, scatter, xyHeatmap, treemap, parCoords, pie, markerMap, combo};
export default _layout;



// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/index.js